export default __webpack_public_path__ + "static/media/LSVDSachsen.8c69a7f5.mp4";